export default "__VITE_ASSET__Dvhlxk9e__"